import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Stage } from 'src/app/Model/stage';
import { StageService } from 'src/app/_services/stage/stage.service';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import { NgbdModalContent } from './SuccessModal.component';
import { HttpClient } from '@angular/common/http';
import { element } from 'protractor';
@Component({
  selector: 'app-add-stage',
  templateUrl: './add-stage.component.html',
  styleUrls: ['./add-stage.component.css']
})
export class AddStageComponent implements OnInit {

 
  autre : any ; 
  control = new FormControl();
  stage = new Stage();
  image: any;
  autres = false; 
  univ = false ; 
  heroForm = new FormGroup({
    name: new FormControl('', [Validators.required,Validators.minLength(5), ])
  });
  get name() { return this.heroForm.get('name'); }
  constructor(private modalService: NgbModal,
              private router: Router,
              private serviceStage : StageService,
              private snotifyService: SnotifyService,private http: HttpClient) { }
            
  filteredunivs : Observable<string[]>;
  univs = [];
  foods: any[] = [
    {value: 'Ariana', viewValue: 'Ariana'}, {value: 'Beja', viewValue: 'Beja'}, {value: 'Ben Arous', viewValue: 'Ben Arous'},  {value: 'Bizerte', viewValue: 'Bizerte'},
    {value: 'Gabes', viewValue: 'Gabes'},  {value: 'Gafsa ', viewValue: 'Gafsa '},  {value: 'Jendouba', viewValue: 'Jendouba'}, {value: 'Kairouan', viewValue: 'Kairouan'},
    {value: 'Kasserine', viewValue: 'Kasserine'}, {value: 'Kebili ', viewValue: 'Kebili '}, {value: 'Kef ', viewValue: 'Kef '}, {value: 'Mahdia', viewValue: 'Mahdia'},
    {value: 'Manouba', viewValue: 'Manouba'}, {value: 'Medenine', viewValue: 'Medenine'}, {value: 'Monastir', viewValue: 'Monastir'},   {value: 'Nabeul', viewValue: 'Nabeul'},
    {value: 'Sfax ', viewValue: 'Sfax '},  {value: 'Sidi Bou Zid ', viewValue: 'Sidi Bou Zid '},   {value: 'Siliana ', viewValue: 'Siliana '}, {value: 'Sousse ', viewValue: 'Sousse '},
    {value: 'Tataouine', viewValue: 'Tataouine'},  {value: 'Tozeur', viewValue: 'Tozeur'},  {value: 'Tunis', viewValue: 'Tunis'},  {value: 'Zaghouan', viewValue: 'Zaghouan'}
  ];
  ngOnInit(): void {

    
  }
  onChange(event) {
      console.log(event);
  //   this.profit.etablissement= event;

  }
  
  handleChange(ev) {

   
      if(ev.source.value=="true")
      {
       // console.log("univ")
        this.univ = true;
        this.autres = false ; 
      }else
      {
        this.autres = true ; 
        this.univ = false ; 
       // console.log("autre")
      }
   
  }
  onSubmit(s)
  {
     let  stages  = new Stage ;
     stages = s ;
    const formData = new FormData();
    formData.append('files', this.image);
    this.http.post<any>('http://notregrandbleu.herokuapp.com/stage/uploads', formData).
    subscribe(res => {
      res.fich.forEach(element => {
     
        stages.cv = element.originalname;
      });
      console.log(stages);
      this.serviceStage.addstage(stages).subscribe(ress=>{
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.name = this.stage.prenom;
     // const modalRef = this.modalService.open(NgbdModalContent);
    //   modalRef.componentInstance.data = this.stage;
   
      this.router.navigate(['/home']);
  
    
    });

    });
  }

  onFileChange(event)
  {
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        this.image = file;
      }
  }
  open() {
   
  }
}
